export const loginHistoryType = {
  GET_LOGIN_HISTORY_LIST_REQUEST: "GET_LOGIN_HISTORY_LIST_REQUEST",
  GET_LOGIN_HISTORY_LIST_SUCCESS: "GET_LOGIN_HISTORY_LIST_SUCCESS",
  GET_LOGIN_HISTORY_LIST_FAIL: "GET_LOGIN_HISTORY_LIST_FAIL"
};
